import CreateDealerModal from "./CreateDealerModal";

export default CreateDealerModal;